import { useBucket } from '@mc/experiments-react'
import { EXPERIMENT_FLAG, type QuizBucket } from '../constants'

export const useCatalogQuizBucket = () => {
  const bucket = useBucket<QuizBucket>(EXPERIMENT_FLAG)

  return { bucket }
}
